import { useCallback, useEffect, useState } from 'react';
import { EditorState } from 'draft-js';
import { stateFromHTML } from 'draft-js-import-html';

import { processStateChanges, stateToHTML } from './utils';

const useSyncedEditorState = (value: string, onChange: (value: string) => void) => {
  const [editorState, setEditorState] = useState(() =>
    EditorState.createWithContent(stateFromHTML(value)),
  );

  useEffect(() => {
    setEditorState((currentEditorState: EditorState) => {
      const currentValue = stateToHTML(currentEditorState.getCurrentContent());
      const decorator = currentEditorState.getDecorator();
      return value !== currentValue
        ? EditorState.createWithContent(stateFromHTML(value), decorator)
        : currentEditorState;
    });
  }, [value]);

  const handleChange = useCallback(
    (editorState: EditorState) => {
      const newEditorState = processStateChanges(editorState);
      const contentState = newEditorState.getCurrentContent();
      setEditorState(newEditorState);
      onChange(stateToHTML(contentState));
    },
    [onChange],
  );

  return { editorState, handleChange };
};

export default useSyncedEditorState;
